<template>
  <div class="mapui-wrapper">
    <div class="center">
      <div class="flex flex-column zoom-map-controls">
        <div class="rectangle my-4">
          <v-btn id="idZonasMas" icon @click="plusZoom" class="secondary--text">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
          <v-divider></v-divider>
          <v-btn id="idZonasMenos" @click="minusZoom" icon class="secondary--text">
            <v-icon>mdi-minus</v-icon>
          </v-btn>
        </div>
      </div>
    </div>
    <div class="bottom">
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            id="idMapaAdministracionActivarTodosLosLugares"
            height="35"
            width="35"
            icon
            color="grey darken-3"
            :loading="$store.state.showPointLoadingButton"
            elevation="2"
            small
            v-bind="attrs"
            v-on="on"
            :class="showPointsOfInterestOnMap ? 'activePointMap' : ''"
            class="mb-2 white"
            @click="showHidePoint()"
          >
            <SvgIcon
              width="23"
              height="23"
              class="secondary--text"
              iconType="icon_points_of_interest"
            />
          </v-btn>
        </template>
        <span>Visualizar Mis Lugares</span>
      </v-tooltip>
      <div class="flex flex-column">
        <v-btn
          id="idBtnZonasSatelital"
          height="35"
          width="35"
          icon
          color="grey darken-3"
          elevation="2"
          small
          :class="showSatelliteMap ? 'activeSatelliteMap' : ''"
          class="mb-2 white"
          @click="toggleMap"
        >
          <SvgIcon
            width="23"
            height="23"
            class="secondary--text"
            iconType="icon_switch_maps"
          />
        </v-btn>
      </div>
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            id="idBtnZonasVisualizar"
            height="35"
            width="35"
            icon
            color="grey darken-3"
            elevation="2"
            small
            v-bind="attrs"
            :loading="$store.state.showGeofenceLoadingButton"
            v-on="on"
            :class="showGeofencesOnMap ? 'active__geofence-map' : ''"
            class="buttons__actions white"
            @click="showHideGeofence()"
          >
            <SvgIcon
              width="23"
              height="23"
              class="secondary--text"
              iconType="icon_geofences"
            />
          </v-btn>
        </template>
        <span>Visualizar Zonas</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
import { SvgIcon } from '@leapsight/styleguide'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    SvgIcon
  },
  data() {
    return {
      userFullName: '',
      showLayersOptions: false,
      showSatelliteMap: false,
      toolbarAppBoxLoading: false,
      services: [],
      mapRef: {}
    }
  },
  mounted() {
    const user = JSON.parse(localStorage.getItem('user'))
    if (user) {
      this.userFullName = `${user.name} ${user.last_name} `
    }
  },
  methods: {
    ...mapActions('uiState', ['toggleMapLayer']),
    ...mapActions('ui', ['toggleGeofenceMapLayer']),
    ...mapActions(['showGeofences', 'showPoints']),
    plusZoom() {
      this.map.setZoom(this.map.getZoom() + 1)
    },
    minusZoom() {
      this.map.setZoom(this.map.getZoom() - 1)
    },
    toggleMap() {
      this.showSatelliteMap = !this.showSatelliteMap
      if (this.map.getMapTypeId() == 'roadmap') {
        this.map.setMapTypeId('hybrid')
      } else this.map.setMapTypeId('roadmap')
    },
    showHideGeofence() {
      let zonesStorage = []
      const geofenceInLS = localStorage.getItem('geofencesSelectedFm') ?? []
      if (typeof geofenceInLS === 'string')
        zonesStorage = JSON.parse(geofenceInLS)
      else zonesStorage = JSON.parse(JSON.stringify(geofenceInLS))

      if (!zonesStorage.length) {
        this.doAllGeofencesSelected()
      } else {
        this.showGeofences({
          map: this.map,
          zonesStorage
        })
      }
    },
    showHidePoint() {
      let pointsStorage = []
      const pointInLs = localStorage.getItem('pointsSelected') ?? []
      if (typeof pointInLs === 'string')
        pointsStorage = JSON.parse(pointInLs)
      else pointsStorage = JSON.parse(JSON.stringify(pointInLs))

      if (!pointsStorage.length) {
        this.doAllPointsSelected()
      } else {
        this.showPoints({
          map: this.map,
          pointsStorage
        })
      }
    },
    doAllGeofencesSelected() {
      try {
        this.loading = true

        this.$store.dispatch('doAllGeofencesSelected', value => {
          this.geofenceSelected = value
          return this.geofenceSelected
        })
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    },
    doAllPointsSelected() {
      try {
        this.loading = true

        this.$store.dispatch('doAllPointsSelected', value => {
          this.pointSelected = value
          return this.pointSelected
        })
      } catch (e) {
        console.error(e)
      } finally {
        this.loading = false
      }
    }
  },
  computed: {
    ...mapGetters('mapState', ['map']),
    ...mapGetters([
      'toolbarAppBoxState',
      'showGeofencesOnMap',
      'getGeofenceInLocalStorage',
      'getPointsInLocalStorage',
      'showGeofence',
      'showPoint',
      'showPointsOfInterestOnMap'
    ]),
  }
}
</script>

<style scoped>
.mapui-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-right: 16px;
}
.center,
.bottom {
  position: absolute;
  z-index: 2;
}

.rectangle {
  width: 35px;
  height: 70px;
  border-radius: 22.5px;
  box-shadow: 0 2px 4px 0 var(--shadow-3-dark);
  background-color: #ffffff;
}
.zoom-map-controls .v-divider {
  max-width: 60%;
  margin: auto;
}
.v-btn:not(.v-btn--text):not(.v-btn--outlined):hover:before {
  opacity: 0;
}

.center {
  top: 50%;
  transform: translateY(-50%);
  max-width: 36px;
}
.bottom {
  bottom: 36px;
  max-width: 36px;
}

.activeSatelliteMap {
  border: 2px solid var(--dark-hot-pink) !important;
}

.active__geofence-map {
  border: 2px solid var(--dark-hot-pink) !important;
}

.activePointMap {
  border: 2px solid var(--dark-hot-pink) !important;
}

.buttons__actions {
  margin-bottom: 50px;
}
</style>
